import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "@/store/store.js";
import Fbuttons from './components/basic/Fbuttons.vue'
import SvgIcon from "@/components/basic/SvgIcon.vue";
import Notifications from 'vue-notification'

import VModal from 'vue-js-modal'

Vue.use(VModal, {dynamic: true, injectModalsContainer: true})
Vue.use(Notifications)

Vue.component('SvgIcon', SvgIcon);


let viewport_meta = '';

// Vue.config.productionTip = false
Vue.component('Buttons', Fbuttons)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'fotty';
  if (to.meta.viewport) {
    if (viewport_meta) return;
    viewport_meta = document.createElement('meta');
    viewport_meta.name = 'viewport';
    viewport_meta.content = 'width=device-width,initial-scale=1.0';
    document.head.appendChild(viewport_meta);
  } else {
    if (viewport_meta) viewport_meta.remove();
  }

  next();
})

export const vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

